import styled from 'styled-components'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import mapImg from '../../assets/mappc.png'
import NaverMap from '../../components/NaverMap'
function Page7Pc(prop) {
  var settings = {
    dots: false,
    infinite: true,
    speed: 400,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    appendDots: (dots) => (
      <div
        style={{
          height: '100px',
          display: 'flex',
          justifyContent: 'center',
          pointerEvents: 'none',
        }}
      >
        <ul
          style={{
            margin: '0',
            padding: '0',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {dots}
        </ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        style={{
          cursor: 'pointer',
          width: '8px',
          height: '8px',
          borderRadius: '8px',
          border: '0.7px solid #f7f7f7',
        }}
      ></div>
    ),
  }

  function getSocialData(list, type) {
    return list.find((item, idx) => item.code == type)
  }

  const { bannerList, socialList } = prop

  return (
    <MainContainer>
      <Text1>이건을 만날 수 있는 곳</Text1>
      <Text2>HOW TO CONTACT</Text2>
      <CustomSlider {...settings}>
        {bannerList &&
          bannerList.map((banner, idx) => {
            return (
              <Slide1 key={idx}>
                <Img
                  src={
                    process.env.REACT_APP_BASE_RESOURCES_API +
                    banner.baFileDto?.filePath
                  }
                ></Img>
              </Slide1>
            )
          })}
      </CustomSlider>
      <Bottom>
        <NaverMap/>
        <Right>
          <ButtonsContainer>
            {socialList &&
              socialList.map((item, idx) => {
                return (
                  <Button
                    key={idx}
                    onClick={() => {
                      window.open(item.soLink, '_blank')
                    }}
                  >
                    <ButtonText1>{item.soTitle.toUpperCase()}</ButtonText1>
                    <ButtonText2>바로가기</ButtonText2>
                  </Button>
                )
              })}
          </ButtonsContainer>
          <RightBottom>
            <BottomText1>이건하우스 본사 직영 전시장</BottomText1>
            <BottomText2>04001 서울시 마포구 동교로 161 (서교동)</BottomText2>
            <br />
            <BottomText2>
              <b>대표번호</b>&nbsp; 1522-1271
            </BottomText2>
            <BottomText2>
              <b>운영시간</b>&nbsp; 평일 10:30 - 19:30
            </BottomText2>
            <BottomText3>
              토요일 10:00 - 17:00
              <br />
              일요일 및 공휴일 휴관
              <br />
              휴게시간 12:00 - 13:00
            </BottomText3>
          </RightBottom>
        </Right>
      </Bottom>
    </MainContainer>
  )
}

export default Page7Pc
const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 82px;
  width: 100vw;
  overflow-x: hidden;
  padding-bottom: 102px;
`
const CustomSlider = styled(Slider)`
  width: 100vw;
  height: 445px;
  overflow: hidden;
`
const Slide1 = styled.div`
  width: 100%;
  height: 445px;
  background: #efefef;
`
const Img = styled.img`
  width: 100%;
  height: 445px;
  object-fit: cover;
`
const Text1 = styled.p`
  font-family: Noto Sans KR;
  font-weight: normal;
  font-size: 39.2px;
  color: #000;
  margin-top: 50px;
  letter-spacing: -0.6px;
`
const Text2 = styled.p`
  font-family: GMarketSans;
  font-weight: 500;
  font-size: 21.1px;
  color: #8e8e8e;
  margin-top: 5px;
  letter-spacing: 0.3px;
  margin-bottom: 17px;
`
const Bottom = styled.div`
  width: 80vw;
  display: flex;
  flex-direction: row;
  gap: 40px;
  margin-top: 90px;
  margin-bottom: 100px;
`
const MapImg = styled.img`
  width: 50vw;
  object-fit: cover;
`
const Right = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`
const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1vw;
`
const Button = styled.div`
  width: 18vw;
  height: 2.2vw;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: #b7a379;
  cursor: pointer;
`
const ButtonText1 = styled.p`
  font-family: GMarketSans;
  font-weight: 500;
  font-size: 1.3vw;
  color: #fff;
  margin-left: 1vw;
`
const ButtonText2 = styled.p`
  font-family: Noto Sans KR;
  font-weight: normal;
  font-size: 1vw;
  color: #fff;
  margin-right: 2vw;
`
const RightBottom = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`
const BottomText1 = styled.p`
  font-family: YESGothic-Regular;
  font-weight: 700;
  font-size: 1.3vw;
  color: #b8a47a;
`

const BottomText2 = styled.p`
  font-family: YESGothic-Regular;
  font-weight: 500;
  font-size: 1vw;
  color: #5b5b5b;
`
const BottomText3 = styled(BottomText2)`
  margin-left: 4.3vw;
`
